import {
    MDBBtn,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRadio
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import TNLocalNumber from "../../views/popups/phonenumbers/TNLocalNumber";
import stepbystep from "../images/stepbystep.svg";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";

export default function TNPorting(props) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [TNPorting, setTNPorting] = useState(false);
    const [TNPortingInner, setTNPortingInner] = useState(false);


    const [selectedRadio, setSelectedRadio] = useState(1); // State to track selected radio button
    const { t, i18n } = useTranslation();
    const [draftInfo, setDraftInfo] = useState(null);
    const handleNextClick = () => {
        setTNPorting(true);
        setTNPortingInner(false);
        if (selectedRadio == "") {
            setSelectedRadio(!TNPorting)
        }
        if (props.setModalHeading) {
            if (selectedRadio === 1) props.setModalHeading(t("TNPortings"));
            else if (selectedRadio === 2) props.setModalHeading(t("TFNPorting"));
            else if (selectedRadio === 3) props.setModalHeading(t("ValidateNumbers"));
        }

    };
    const handlePrevClick = () => {
        setTNPorting(false);

    }
    const handleRadioChange = (value) => {
        // setTNPorting(false);
        setSelectedRadio(value);
    };

    const [Page, setPage] = useState(1);
    console.log(Page);

    useEffect(() => {
        if (props.isActive) {
            setPage(1);
        }
        else {
            setSelectedRadio(1)
            if (props.setModalHeading) {
                props.setModalHeading(t("TNPortingValidation"))
            }
        }

    }, [props.isActive])

    useEffect(() => {
        if (props.draftPortingType) {
            setSelectedRadio(props.draftPortingType)
        }

    }, [props.draftPortingType])

    useEffect(() => {
        if (props.draftInfo) {
            setDraftInfo(props.draftInfo);
            setPage(3);
        }

    }, [props.draftInfo])



    return (
        <>
            <div className="tnPortingContainer">
                {
                    Page == 1 ? <>
                        <div className="container tnStepOne">
                            <h5 className="fw-600 pb-4">Select Number Type:</h5>
                            <div className="pb-3 d-flex justify-content-between align-items-center w-80 sm-w-100 customRadios">
                                <div className="custom-checkbox shadow-4">
                                    <MDBRadio
                                        name='radioNoLabel' className="radio-custom"
                                        id='radioNoLabel1'
                                        label='US/Canadian Local Number'
                                        aria-label='...'
                                        checked={selectedRadio === 1}
                                        onChange={() => handleRadioChange(1)}
                                    />
                                </div>
                                <div className="custom-checkbox shadow-4">
                                    <MDBRadio
                                        name='radioNoLabel' className="radio-custom"
                                        id='radioNoLabel2'
                                        label='US/Canadian Toll Free Number'
                                        aria-label='...'
                                        checked={selectedRadio === 2}
                                        onChange={() => handleRadioChange(2)}
                                    />
                                </div>
                                <div className="custom-checkbox shadow-4">
                                    <MDBRadio
                                        name='radioNoLabel' className="radio-custom"
                                        id='radioNoLabel3'
                                        label='Number Validation Only'
                                        aria-label='...'
                                        checked={selectedRadio === 3}
                                        onChange={() => handleRadioChange(3)}
                                    />
                                </div>
                            </div>
                        </div>


                        <MDBModalFooter className="d-flex">
                            {/* <MDBBtn color='secondary'>
                                Save to Draft
                            </MDBBtn> */}
                            <div className="text-end">
                                {
                                    Page < 2 ? (
                                        <MDBBtn color='secondary' onClick={(e => props.closePopup(e))}>
                                            Cancel
                                        </MDBBtn>
                                    ) : (
                                        <MDBBtn color='secondary' onClick={() => {
                                            const nextPage = Page - 1;
                                            setPage(nextPage);
                                        }}>
                                            Previous
                                        </MDBBtn>
                                    )
                                }
                                {
                                    Page < 3 ? (
                                        <MDBBtn onClick={() => {
                                            handleNextClick();
                                            const nextPage = Page + 1;
                                            setPage(nextPage);
                                        }} className="ms-2">Next</MDBBtn>
                                    ) : (
                                        <MDBBtn className="ms-2">
                                            Save
                                        </MDBBtn>
                                    )
                                }
                            </div>
                        </MDBModalFooter>
                    </> : Page == 2 ? <>
                        {(selectedRadio === 1 || selectedRadio === 2) && (
                            <>
                                <div className="tnStepOne">
                                    <div className="">
                                        <div className="col-lg-12">
                                            <div className="text-center mt-3">

                                                <h5 className="fw-600">
                                                    {selectedRadio === 1 ? 'Telephone Number Porting' : 'Toll Free Number Porting'}
                                                </h5>

                                                <div className="my-4">
                                                    <img src={stepbystep} className="w-80" />
                                                </div>
                                                <h5 className="fw-600 my-4">
                                                    Step By Step
                                                </h5>
                                                <p>Use our guide in Porting Telephone Numbers</p>

                                                <a className="text-primary my-3 checklistTooltip">Checklist(what is needed)</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <MDBModalFooter className="d-flex">
                                    {/* <MDBBtn color='secondary'>
                                        Save to Draft
                                    </MDBBtn> */}
                                    <div className="text-end">
                                        {
                                            Page < 2 ? (
                                                <MDBBtn color='secondary' onClick={(e => props.closePopup(e))}>
                                                    Cancel
                                                </MDBBtn>
                                            ) : (
                                                <MDBBtn color='secondary' onClick={() => {
                                                    const nextPage = Page - 1;
                                                    setPage(nextPage);
                                                }}>
                                                    Previous
                                                </MDBBtn>
                                            )
                                        }
                                        {
                                            Page < 3 ? (
                                                <MDBBtn onClick={() => {
                                                    const nextPage = Page + 1;
                                                    setPage(nextPage);
                                                }} className="ms-2">Next</MDBBtn>
                                            ) : (
                                                <MDBBtn className="ms-2">
                                                    Save
                                                </MDBBtn>
                                            )
                                        }
                                    </div>
                                </MDBModalFooter>
                            </>
                        )}
                        {/* {selectedRadio === 2 && (
                            <>
                                <div className="tnStepOne">
                                    <div className="">
                                        <div className="col-lg-12">
                                            <div className="text-center mt-3">

                                                <h5 className="fw-600">
                                                    Toll Free Number Porting
                                                </h5>

                                                <div className="my-4">
                                                    <img src={stepbystep} className="w-80" />
                                                </div>
                                                <h5 className="fw-600 my-4">
                                                    Step By Step
                                                </h5>
                                                <p>Use our guide in Porting Telephone Numbers</p>
                                                <a className="text-primary my-3">Checklist(what is needed)</a>

                                                <div className="text-start" id="userguidepopup">
                                                    <div className="mb-3">You need the following prerequisites to port your number successfully. You can start the process and save a draft and return to it later if needed.</div>
                                                    <h5>Checklist for Porting:</h5>
                                                    <div>
                                                        <ul>
                                                            <li>You can provide a copy of the latest bill or CSR (customer service record) from your current carrier provider as proof of TN/TFN ownership.</li>
                                                            <li>If you have multiple bills, the port request must be submitted for each bill separately.</li>
                                                            <li>Phone Numbers that you want to port must be active.</li>
                                                            <li>Have no open orders with your current carrier provider.</li>
                                                            <li>Have no additional telephone services associated with your number, like huntgroups, voicemail, etc.</li>
                                                            <li>Have no DSL/Broadband associated to any of the porting numbers.</li>
                                                            <li>You have your IP Phones or Softphones ready.</li>
                                                            <li>Do not submit an order to cancel the current service until the port is successfully completed.</li>
                                                            <li>A port date cannot be requested sooner than 7 business days from the date of submission.</li>
                                                            <li>If copy of the latest bill or CSR does not have a Billing Telephone Number for the account, add one number from porting numbers as BTN.</li>
                                                            <li>If a federal holiday is chosen as a transfer date, then the order will receive a FOC date for the next business day after the holiday.</li>
                                                            <li>All porting is completed @ 11 am EST.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <MDBModalFooter className="d-flex justify-content-between">
                                    <MDBBtn color='secondary'>
                                        Save to Draft
                                    </MDBBtn>
                                    <div className="text-end">
                                        {
                                            Page < 2 ? (
                                                <MDBBtn color='secondary'>
                                                    Cancel
                                                </MDBBtn>
                                            ) : (
                                                <MDBBtn color='secondary' onClick={() => {
                                                    const nextPage = Page - 1;
                                                    setPage(nextPage);
                                                }}>
                                                    Previous
                                                </MDBBtn>
                                            )
                                        }
                                        {
                                            Page < 3 ? (
                                                <MDBBtn onClick={() => {
                                                    const nextPage = Page + 1;
                                                    setPage(nextPage);
                                                }} className="ms-2">Next</MDBBtn>
                                            ) : (
                                                <MDBBtn className="ms-2">
                                                    Save
                                                </MDBBtn>
                                            )
                                        }
                                    </div>
                                </MDBModalFooter>
                            </>
                        )} */}

                        {selectedRadio === 3 && (
                            <TNLocalNumber
                                portingType={selectedRadio}
                                portingSave={props.portingSave}
                                setportingSave={props.setportingSave}
                                TabSwitchWarn={props.TabSwitchWarn}
                                setTabSwitchWarn={props.setTabSwitchWarn}
                                setCentredModal2={props.setCentredModal2}
                                setisDraft={props.setIsDraft}
                                draftInfo={draftInfo}
                                setcloseFlag={props.setcloseFlag}
                            />
                        )}

                    </> : Page == 3 ? <>
                        <TNLocalNumber
                            portingType={selectedRadio}
                            portingSave={props.portingSave}
                            setportingSave={props.setportingSave}
                            TabSwitchWarn={props.TabSwitchWarn}
                            setTabSwitchWarn={props.setTabSwitchWarn}
                            setCentredModal2={props.setCentredModal2}
                            setisDraft={props.setIsDraft}
                            draftInfo={draftInfo}
                            setcloseFlag={props.setcloseFlag}
                        />

                    </> : null
                }
            </div>

            <div >





















                {/* <div className='w-100 d-flex flex-column-reverse'>
                    <div className='mb-3 w-100 d-flex justify-content-end'>
                        <MDBBtn ref={prevRef} className="me-3" color="secondary">Previous</MDBBtn>
                        <MDBBtn ref={nextRef} onClick={handleNextClick}  >
                            Next
                        </MDBBtn>
                    </div>
                    <div>
                        <MDBStepper externalNext={nextRef} externalPrev={prevRef}>
                            <MDBStepperStep headIcon={1} itemId={1} headText={"TN Porting and Validation"}>


                            </MDBStepperStep>

                            <MDBStepperStep headIcon={2} itemId={2} headText={"TN/TFN Porting"}>

                                <div className="">
                                    <div className="col-lg-12">
                                        <div className="text-center mt-3">

                                            <h5 className="fw-600">
                                                Telephone Number Porting
                                            </h5>

                                            <div className="my-4">
                                                <img src={stepbystep} className="w-30" />
                                            </div>
                                            <h5 className="fw-600 my-4">
                                                Step By Step
                                            </h5>
                                            <p>Use our guide in Porting Telephone Numbers</p>
                                            <a className="text-primary my-3">Checklist(what is needed)</a>

                                            <div className="text-start" id="userguidepopup">
                                                <div className="mb-3">You need the following prerequisites to port your number successfully. You can start the process and save a draft and return to it later if needed.</div>
                                                <h5>Checklist for Porting:</h5>
                                                <div>
                                                    <ul>
                                                        <li>You can provide a copy of the latest bill or CSR (customer service record) from your current carrier provider as proof of TN/TFN ownership.</li>
                                                        <li>If you have multiple bills, the port request must be submitted for each bill separately.</li>
                                                        <li>Phone Numbers that you want to port must be active.</li>
                                                        <li>Have no open orders with your current carrier provider.</li>
                                                        <li>Have no additional telephone services associated with your number, like huntgroups, voicemail, etc.</li>
                                                        <li>Have no DSL/Broadband associated to any of the porting numbers.</li>
                                                        <li>You have your IP Phones or Softphones ready.</li>
                                                        <li>Do not submit an order to cancel the current service until the port is successfully completed.</li>
                                                        <li>A port date cannot be requested sooner than 7 business days from the date of submission.</li>
                                                        <li>If copy of the latest bill or CSR does not have a Billing Telephone Number for the account, add one number from porting numbers as BTN.</li>
                                                        <li>If a federal holiday is chosen as a transfer date, then the order will receive a FOC date for the next business day after the holiday.</li>
                                                        <li>All porting is completed @ 11 am EST.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </MDBStepperStep>

                            <MDBStepperStep headIcon={3} headText='step 3' itemId={3}>
                                <TNportingStep3 />
                            </MDBStepperStep>
                        </MDBStepper>
                    </div>
                </div> */}
            </div>

            <Tooltip anchorSelect=".checklistTooltip" place="top" className="my-tooltip-inline">


                <div className="text-start text-white">
                    <div className="mb-3">You need the following prerequisites to port your number successfully. You can start the process and save a draft and return to it later if needed.</div>
                    <h5>Checklist for Porting:</h5>
                    <div>
                        <ul>
                            <li>You can provide a copy of the latest bill or CSR (customer service record) from your current carrier provider as proof of TN/TFN ownership.</li>
                            <li>If you have multiple bills, the port request must be submitted for each bill separately.</li>
                            <li>Phone Numbers that you want to port must be active.</li>
                            <li>Have no open orders with your current carrier provider.</li>
                            <li>Have no additional telephone services associated with your number, like huntgroups, voicemail, etc.</li>
                            <li>Have no DSL/Broadband associated to any of the porting numbers.</li>
                            <li>You have your IP Phones or Softphones ready.</li>
                            <li>Do not submit an order to cancel the current service until the port is successfully completed.</li>
                            <li>A port date cannot be requested sooner than 7 business days from the date of submission.</li>
                            <li>If copy of the latest bill or CSR does not have a Billing Telephone Number for the account, add one number from porting numbers as BTN.</li>
                            <li>If a federal holiday is chosen as a transfer date, then the order will receive a FOC date for the next business day after the holiday.</li>
                            <li>All porting is completed @ 11 am EST.</li>
                        </ul>
                    </div>
                </div>


            </Tooltip>

        </>
    );

}
